<div class="dialog">
  <h3>Dodaj kategorijo</h3>
  <form (ngSubmit)="onSave()">
    <label>
      Ime kategorije:
      <input type="text" [(ngModel)]="category_name" name="category_name" required />
    </label>
    <div class="dialog-actions">
      <button type="submit">Shrani</button>
      <button type="button" (click)="onCancel()">Prekliči</button>
    </div>
  </form>
</div>